import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'portal-ebeihilfe-not-found-404',
    imports: [TranslateModule],
    templateUrl: './not-found-404.component.html',
    styleUrl: './not-found-404.component.scss'
})
export class NotFound404Component {}
